import { createFileRoute, redirect } from "@tanstack/react-router";

// The algemene voorwaarden live in ONE place: the website (`apps/website`, /terms page +
// build-time-generated /tos.pdf). The portal no longer renders its own copy — this route
// only survives because old links point at it.
export const Route = createFileRoute("/$locale/{-$schoolyear}/tos")({
  beforeLoad: () => {
    throw redirect({ href: "https://beweegbaas.nl/terms" });
  },
});
